import { WebConsentDocusignType } from '../types/hcpOnboarding.types'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: WebConsentDocusignType = {
  docusignPdfUrl: null,
  tenantId: null,
  caseId: null,
  persona: null,
  brandingData: null,
  statesDropdownData: null,
  fieldValidationData: {},
  mecPortalMetaData: null,
  mecPortalToken: null,
  counter: 0,
  messageVerbiageData: {
    success: '',
    error: '',
    loading: '',
    expiry: '',
  },
  selectedDocumentIds: '',
  paramToken: null,
  isLinkExpired: false,
  linkExpiredMsg: '',
}
type MessageVerbiageKeys = keyof WebConsentDocusignType['messageVerbiageData']

const webConsentSlice = createSlice({
  name: 'webConsent',
  initialState: initialState,
  reducers: {
    updateDocusignUrl: (state: WebConsentDocusignType, action) => {
      state.docusignPdfUrl = action?.payload
    },
    updateSelectedDocumentIds: (state: WebConsentDocusignType, action) => {
      state.selectedDocumentIds = action?.payload
    },
    updateMECPortalMessageVerbiageData: (
      state: WebConsentDocusignType,
      action
    ) => {
      state.messageVerbiageData = action?.payload
    },
    updateMECPortalIndividualMessageVerbiageData: (
      state: WebConsentDocusignType,
      action: PayloadAction<{ key: MessageVerbiageKeys; value: string }>
    ) => {
      state.messageVerbiageData[action.payload.key] = action.payload.value
    },
    updateCounter: (state: WebConsentDocusignType, action) => {
      state.counter = action?.payload
    },
    updateMECPortalToken: (state: WebConsentDocusignType, action) => {
      state.mecPortalToken = action?.payload
    },
    updateMECPortalMetaData: (state: WebConsentDocusignType, action) => {
      state.mecPortalMetaData = action?.payload
    },
    updateFieldValidationData: (state: WebConsentDocusignType, action) => {
      state.fieldValidationData = action?.payload
    },
    updateStatesDropdownData: (state: WebConsentDocusignType, action) => {
      state.statesDropdownData = action?.payload
    },
    updateDocusignSuccessInfo: (state: WebConsentDocusignType, action) => {
      state.tenantId = action?.payload?.tenantId
      state.persona = action?.payload?.persona
      state.caseId = action?.payload?.caseId
    },
    updateMECBrandingConsentData: (state: WebConsentDocusignType, action) => {
      state.brandingData = action.payload
    },
    updateParamToken: (state: WebConsentDocusignType, action) => {
      state.paramToken = action?.payload
    },
    setMECLinkExpired: (
      state: WebConsentDocusignType,
      action: PayloadAction<{ isExpired: boolean; msg: string }>
    ) => {
      state.isLinkExpired = action.payload.isExpired
      state.linkExpiredMsg = action.payload.msg
    },
  },
})

export const {
  updateDocusignUrl,
  updateDocusignSuccessInfo,
  updateMECBrandingConsentData,
  updateStatesDropdownData,
  updateFieldValidationData,
  updateMECPortalMetaData,
  updateMECPortalToken,
  updateCounter,
  updateMECPortalMessageVerbiageData,
  updateSelectedDocumentIds,
  updateMECPortalIndividualMessageVerbiageData,
  updateParamToken,
  setMECLinkExpired,
} = webConsentSlice.actions
export default webConsentSlice.reducer
